import { MutationTree } from "vuex";
import { IModalState } from "./interface";

export default <MutationTree<IModalState>> {

	setModal(state) {
		state.isModal = !state.isModal;
	}

};